import { Checkbox, Form, Icon } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import ModalTiers from './ModalTiers';

const ReglementTiers = (props) => {
  const {
    tiers,
    civilites = [
      {
        key: 'madame',
        value: 'Madame',
        text: 'Mme.',
      },
      {
        key: 'monsieur',
        value: 'Monsieur',
        text: 'Mr.',
      },
    ],
    onTiersChange,
  } = props;

  // Etat de la modale
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleToggle = React.useCallback(() => {
    setModalOpen(!modalOpen);
  }, [modalOpen]);

  /**
   * Gère l'activation ou désactivation d'un règlement par un tiers
   */
  const handleReglementTiersChange = React.useCallback(() => {
    // Si on a aucun tiers c'est qu'on veut en ajouter un
    if (_.isEmpty(tiers)) {
      handleToggle();
    } else {
      // Sinon on le supprime car on veut désactiver le règlement par un tiers
      onTiersChange(null);
    }
  }, [handleToggle, onTiersChange, tiers]);

  const handleValidate = React.useCallback(
    (selected) => {
      onTiersChange(selected);
      handleToggle();
    },
    [handleToggle, onTiersChange],
  );

  const adresseAffiche = tiers?.adresse
    ? _.words(
        `${_.toString(tiers.adresse.numeroVoirie)} ${tiers.adresse.indiceRepetition} ${tiers.adresse.voie} ${tiers.adresse.codePostal} ${tiers.adresse.commune}`,
      ).join(' ')
    : '';

  return (
    <>
      <Form.Field
        // @ts-expect-error
        style={{ display: 'flex' }}
      >
        <Checkbox
          data-testid="reglement-tiers-checkbox"
          toggle
          onChange={handleReglementTiersChange}
          checked={!_.isEmpty(tiers)}
        />
      </Form.Field>
      <label>
        Règlement par un tiers
        {!_.isEmpty(tiers) && ' :'}
      </label>
      <Form.Field
        // @ts-expect-error
        style={{ flex: 1 }}
      >
        {!_.isNil(tiers) && (
          <>
            <label>
              {`${_.find(civilites, { value: tiers.civilite })?.text || ''} ${_.upperFirst(tiers.nom) || ''} ${_.upperFirst(tiers.prenom) || ''}`}
              {tiers.adresse?.voie && ` à l'adresse ${adresseAffiche}`}
            </label>
            <Icon link name="edit" onClick={handleToggle} />
          </>
        )}
      </Form.Field>
      {modalOpen && (
        <ModalTiers
          selected={tiers}
          civilites={civilites}
          onClose={handleToggle}
          onValidate={handleValidate}
        />
      )}
    </>
  );
};

export default ReglementTiers;
